import React from 'react';

import S from 'constants/string.const';

const TooltipContentComingSoon = () => (
  <div data-bem="TooltipContentComingSoon">
    {S.partyingFace}
    {S.space}Coming Soon!
  </div>
);

export default TooltipContentComingSoon;
